<template>
  <v-app>
    <v-app-bar :color="mainColor" class="lighten-3" app>
      <v-toolbar-title>Amtstafel Marktgemeinde St. Leonhard am Hornerwald</v-toolbar-title>
    </v-app-bar>
    <v-main style="padding-bottom: 150px">
      <Amtstafel :start-url="startUrl" :main-color="mainColor" />
    </v-main>
      <v-sheet :color="mainColor" class="d-flex flex-column pa-3 lighten-3" style="position: fixed; left: 0px; bottom: 0px; width: 100%">
        <v-container >
          <v-row>
            <v-col sm="4" cols="12" v-if="$vuetify.breakpoint.smAndUp">
              <v-btn block class="font-weight-bold rounded-lg mx-2 mb-2 body-1 py-6 px-3" outlined @click="startUrl='https://st-leonhard-am-hornerwald.riskommunal.net/Buergerservice/Aktuelles/Amtstafel'">Amtstafel</v-btn>
            </v-col>
            <v-col sm="4" cols="12">
              <v-btn block class="font-weight-bold rounded-lg mx-2 mb-2 body-1 py-6 px-3" outlined href="https://geminfo.app/marktgemeinde-sankt-leonhard">Geminfo.app</v-btn>
            </v-col>
            <v-col sm="4" cols="12" v-if="$vuetify.breakpoint.smAndUp">
              <v-btn block class="font-weight-bold rounded-lg mx-2 mb-2 body-1 py-6 px-3" outlined href="https://www.sankt-leonhard.at/">Marktgemeinde</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
  </v-app>
</template>

<style lang="sass">
  .v-card__title
    word-break: break-word !important
    *
      word-break: break-word !important

</style>

<script>
import Amtstafel from './components/AmtstafelStleonhard.vue';

export default {
  name: 'AppStleonhard',

  components: {
    Amtstafel,
  },

  data: () => ({
    startUrl: "https://st-leonhard-am-hornerwald.riskommunal.net/Buergerservice/Aktuelles/Amtstafel",
    mainColor: "yellow",
  }),
};
</script>
